import React, { useContext } from "react";
import AppContext from "../../context/appContext";
import visuallyHiddenSx from "../../utils/a11y/visuallyHiddenSx";
import "./styles/GlassLoading.scss";

const GlassLoading = () => {
  const appContext = useContext(AppContext);

  return (
    appContext.showGlassLoading && (
      <div id="GlassLoading" role="status">
        <span style={visuallyHiddenSx}>Carregando…</span>
        <div className="loadingCircle" aria-hidden="true" />
      </div>
    )
  );
};

export default GlassLoading;
